var SignUpButton  = require("app/Auth/SignUpButton"),
    config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    isIosApp      = require("app/utils/isIosApp"),
    kind          = require("enyo/kind");

require("./SignUpCta.less");
require("app/theme/IconButton--positive.less");

module.exports = kind(/** @lends  app.Bookmarks.SignUpCta.prototype */ {

    /**
     * @private
     */
    name: "app.Bookmarks.SignUpCta",

    /**
     * @private
     */
    classes: "app-bookmarks-sign-up-cta",

    /**
     * Don't show if signup is disabled or if we're running as IOS app
     *
     * @private
     */
    canGenerate: get(config, "signup.enabled", true) && !isIosApp,

    /**
     * @private
     */
    components: [{
        name:    "title",
        classes: "app-bookmarks-sign-up-cta__title",
        tag:     "h1"
    }, {
        name:    "body",
        classes: "app-bookmarks-sign-up-cta__body",
        tag:     "p"
    }, {
        name:    "signUpButton",
        kind:    SignUpButton,
        classes: "app-bookmarks-sign-up-cta__sign-up-button",
        theme:   "positive"
    }],

    /**
     * @private
     */
    handlers: {
        onCancelButtonTap: "onCancelButtonTap"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService;

        this.$.title.set("content", i18nService.getString("app.Bookmarks.SignUpCta.title"));
        this.$.body.set("content", i18nService.getString("app.Bookmarks.SignUpCta.body"));
    }

});
